import { Footer, Header } from '../../components';
import { constant } from '../../utils';
import styles from './style.module.scss';

export default function Page() {
  const deviceWidth = window.innerWidth;
  const deviceHeight = window.innerHeight;

  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.content}>
        <div className={styles.section}>
          <div className={styles.row}>
            <div className={styles.title}>CONTACT</div>
            <div className={styles.desc}>
              <div className={styles.kr}>
                오후에서 머무는 시간이 좋은 기억으로 남을 수 있도록
                노력하겠습니다. 감사합니다.
              </div>
              <div className={styles.en}>
                We hope your stay at Residence OHU is a pleasant and memorable
                one. Thank you!
              </div>
              <div className={styles.info}>
                <div className={styles.kr}>서울시 마포구 월드컵북로 88</div>
                <div className={styles.en}>
                  88, World Cup buk-ro, Mapo-gu, Seoul, Republic of Korea
                </div>
                <div className={styles.kr}>
                  <a href={`mailto:${constant.email}`}>{constant.email}</a>
                </div>
                <div className={styles.en}>
                  <a href={`tel:821086889290`}>T. +82 10 8688 9290</a>
                  <span>Contact hours 10:00 ~ 20:00 KST</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3162.7230330358975!2d126.91057668978998!3d37.56158869994696!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c997e573915bf%3A0xc10a6c495b953f17!2z66CI7KeA642Y7IqkIOyYpO2bhCDsl6zshLHsoITsmqkg7ZSE66as66-47JeEIOybkOujuO2FlCDtmY3rjIDsoJA!5e0!3m2!1sko!2skr!4v1770395977301!5m2!1sko!2skr"
            width="100%"
            height={deviceWidth > 540 ? deviceHeight : 686}
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
      <Footer />
    </div>
  );
}
